import ProductWithReviewsSimpleView from './ProductWithReviewsSimpleView'

export default ProductWithReviewsSimpleView
